import React from 'react';
import { Card } from '~/components/Card';

export function HipaaComponent() {
    return (
        <Card className="my-3 hipaa-card" tabIndex={0}>
            <div className="row">
                <div className="col pb-3">
                    <p className="fw-bold">HIPAA Privacy Statement</p>
                    <p>
                        WellMed Medical Management, Inc. and their affiliated entities are obligated
                        to protect the privacy of individual health information in accordance with
                        applicable law and all WellMed Medical Management, Inc. policies and
                        procedures related to privacy and security of individually identifiable
                        health information. All employees, contractors, and temporary personnel must
                        be aware of and adhere to these obligations.
                    </p>
                    <p>
                        Reasonable efforts to limit use, disclosure and requests of PHI to the
                        minimum necessary to carry out the intended purpose of the use, disclosure
                        or request will be made wherever such standard is applicable.
                    </p>
                    <p>
                        As a part of this obligation in accessing the Zephyr system, you hereby
                        agree to maintain the confidentiality of protected health information that
                        you access in this system. In addition, you agree to abide by privacy and
                        security laws and regulations issued by the United States Department of
                        Health and Human Services under the Health Insurance Portability and
                        Accountability Act of 1996 (&quot;HIPAA&quot;) and the privacy and security
                        breach notification provisions under the Health Information Technology for
                        Economic and Clinical Health Act (&quot;HITECH&quot;) which is Title XIII of
                        the American Recovery and Reinvestment Act of 2009.
                    </p>
                    <p>
                        If you are the medical practice owner or authorized agent/delegate of the
                        owner, you are responsible for managing access for your staff. This includes
                        both the review of current users and removing access when no longer
                        required, at the earliest possible moment. If you have any questions, please
                        reach out to EntitlementReview@wellmed.net.
                    </p>
                    <p>
                        <span className="fw-bold">Notice:</span> Printing or saving of patient
                        information from this application onto a personal device or practice printer
                        will become your personal or practice responsibility to protect. Please
                        ensure appropriate security, encryption, and/or destruction of any saved
                        content from this site.
                    </p>
                </div>
            </div>
        </Card>
    );
}
